import { supabase } from '../../../services/supabase';
/**
 * Check if a user is assigned as a reviewer in the current review cycle
 * @param userId - User ID to check
 * @returns Promise<boolean> - True if user is assigned as reviewer
 */
export async function checkReviewerAssignment(
  userId: string,
): Promise<boolean> {
  if (!userId) {
    return false;
  }

  try {
    // Check if user has any active reviewer relations for the current cycle
    const { data: reviewerRelations, error: relationsError } = await supabase
      .from('enps_reviewer_relations')
      .select('reviewer_id')
      .eq('reviewer_id', userId)
      .is('end_date', null) // Only active relationships
      .limit(1);

    if (relationsError) {
      console.error('Error fetching reviewer relations:', relationsError);
      throw new Error(
        `Failed to fetch reviewer relations: ${relationsError.message}`,
      );
    }

    // User is assigned as reviewer if they have any active relations
    return reviewerRelations && reviewerRelations.length > 0;
  } catch (error) {
    console.error('Error checking reviewer assignment:', error);
    throw error;
  }
}
